const FontSizeSliderHook = {
  mounted() {
    this.el.addEventListener('input', (e) => {
      const value = e.target.value;
      const targetInput = document.getElementById(this.el.dataset.targetInput);
      if (targetInput) {
        targetInput.value = value;
        // Trigger a change event on the hidden input to update the form
        targetInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
};

export default FontSizeSliderHook;
